module.exports = __webpack_public_path__ + "img/30.ba1d4e4a.jpg";